import { render } from "./SoundManagerPropsCmp.vue?vue&type=template&id=3fa71278"
import script from "./SoundManagerPropsCmp.vue?vue&type=script&lang=js"
export * from "./SoundManagerPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__